// src/components/manager/ProductList.js
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { AiFillEye, AiFillEdit } from "react-icons/ai";
import { API_BASE_URL } from "../../config";

const ProductList = ({ products }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate total pages
  const totalPages = Math.ceil(products.length / itemsPerPage);

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = products.slice(0, indexOfLastItem);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "ADMIN") {
      setIsEdit(true);
    }
  }, []);

  const loadMore = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  return (
    <div className="show-detils">
      {currentItems.length > 0 ? (
        <>
          <div className="table-responsive">
            <table className="table table-dark table-striped">
              <thead>
                <tr>
                  <th>Actions</th>
                  <th>Time</th>
                  <th>Oil Total</th>
                  <th>Cake Total</th>
                  <th>Today Total</th>
                  <th>Credit</th>
                  <th>Deposit</th>
                  <th>Expenses</th>
                  <th>Card</th>
                  <th>Total</th>
                  <th>Final Total</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((entry, i) => (
                  <tr key={i}>
                    <td>
                      <Link
                        className="btn btn-info btn-sm me-1"
                        to={`/managerreadingdetail/${entry.id}`}
                        title="View Details"
                      >
                        <AiFillEye />
                      </Link>
                      {isEdit && (
                        <Link
                          className="btn btn-warning btn-sm"
                          to={`/managerreadingedit/${entry.id}`}
                          title="Edit"
                        >
                          <AiFillEdit />
                        </Link>
                      )}
                    </td>
                    {/* <td>{new Date(entry.created_at).toLocaleString()}</td> */}
                    <td>
                      {entry.created_at
                        ? new Date(entry.created_at).toString() ===
                          "Invalid Date"
                          ? entry.created_at
                          : new Date(entry.created_at).toLocaleString()
                        : "N/A"}
                    </td>

                    <td>{entry.oil_total_amount || "0"}</td>
                    <td>{entry.cake_total_amount || "0"}</td>
                    <td>{entry.grandTotal || "0"}</td>
                    <td>{entry.total_credit || "0"}</td>
                    <td>{entry.total_deposit || "0"}</td>
                    <td>{entry.total_expinese || "0"}</td>
                    <td>{entry.total_card || "0"}</td>
                    <td>{entry.net_total || "0"}</td>
                    <td className="fw-bold">{entry.final_total || "0"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Load More Button */}
          {currentPage < totalPages && (
            <div className="text-center m-3">
              <button onClick={loadMore} className="btn btn-primary">
                Load More ({currentItems.length} of {products.length} shown)
              </button>
            </div>
          )}

          {/* Show when all items are loaded */}
          {currentPage >= totalPages && products.length > 0 && (
            <div className="text-muted text-center mt-2">
              Showing all {products.length} items
            </div>
          )}
        </>
      ) : (
        <div className="alert alert-info">No records found</div>
      )}
    </div>
  );
};

export default ProductList;
